import { Navigate } from "react-router-dom";
import { useLocalStorageState } from "../hooks/useLocalStorageState";

function RestrictedRoute({ children }: { children: JSX.Element }) {
  const [currentUserId] = useLocalStorageState("currentUserId");
  const isVerifyNeeded = sessionStorage.getItem("needToVerify") === "true";

  if (!isVerifyNeeded) {
    return <Navigate to={currentUserId ? `/?token=${currentUserId}` : "/"} replace />;
  }

  return children;
}

export default RestrictedRoute;
